import React from 'react'

import type { SwitchboardTranslateFn } from './i18n.types'

export const SwitchboardI18nContext = React.createContext<
  SwitchboardTranslateFn | undefined
>(undefined)

export function useSwitchboardT(): SwitchboardTranslateFn | undefined {
  return React.useContext(SwitchboardI18nContext)
}
